import { PATH } from '@/constants/path';
import highlightPreviewSlice, { HighlightPreviewStateKeys } from '@/redux/slice/highlightPreview.slice';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

const useClickHighlight = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const handleClickHighlight = (key: HighlightPreviewStateKeys) => () => {
    if (location.pathname !== PATH.APPEARANCE.pathname) return;
    setTimeout(() => {
      dispatch(highlightPreviewSlice.actions.handleClickHighlightItem({ key, value: true }));
    }, 0);
  };
  return { handleClickHighlight };
};

export default useClickHighlight;
